import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import uniq from "lodash/uniq";
import { useIsSmartPlannerView } from "PFApp/booking/hooks/use_is_smart_planner_view";
import { useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { RowType } from "PFApp/booking/types";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { useBookingsForUpdate } from "PFCore/hooks/queries/bookings/bulk_operation/use_bookings_for_update";
import { useBookingsForUpdateInvalidate } from "PFCore/hooks/queries/bookings/bulk_operation/use_bookings_for_update_invalidate";
import { useEffect } from "react";

import { useCalendarGridScope } from "../../parts/hooks";
import { usePastDatesStateContext } from "../../parts/overview/booking_module_calendar/booking_calendar/past_dates_context";
import { useBookingEditModeStoreActions } from "../booking_edit_mode_store";

export const useSmartPlannerData = () => {
  const { smartPlannerMode } = useBookingEditModeStoreActions();

  const calendarRoot = useCalendarRoot();
  const profileIds = useBookingModuleStore((state) =>
    map(filter(state[calendarRoot].rows, { type: RowType.Profile }), "original.id")
  );

  const { invalidate } = useBookingsForUpdateInvalidate();
  const { pastFetchesCount } = usePastDatesStateContext();
  const dateRange = useCalendarGridScope({ pastFetchesCount });

  const isSmartPlannerView = useIsSmartPlannerView();

  const uniqueProfileIds = uniq(profileIds);

  const payload = {
    filters: [{ profileId: uniqueProfileIds }],
    dateRange,
    page: 1,
    perPage: PER_PAGE_UNPAGINATED
  };

  const { data: bookingsForUpdateData, isFetching } = useBookingsForUpdate("smart_planner", payload, {
    enabled: isSmartPlannerView && !isEmpty(uniqueProfileIds)
  });

  useEffect(() => {
    if (bookingsForUpdateData && isSmartPlannerView) {
      const updatableIds = bookingsForUpdateData.entries.map(({ id }) => id);
      smartPlannerMode.setUpdatableBookingIds(updatableIds);
    }
  }, [bookingsForUpdateData, smartPlannerMode, isSmartPlannerView]);

  useEffect(() => {
    smartPlannerMode.setIsLoading(isFetching);
  }, [isFetching, smartPlannerMode]);

  useEffect(() => {
    if (!isSmartPlannerView) {
      invalidate("smart_planner");
      smartPlannerMode.reset();
    }
  }, [isSmartPlannerView, invalidate, smartPlannerMode]);
};
